import React from 'react';

const StatCard = ({ title, value, icon: Icon, color, darkColor }) => (
  <div className={`bg-white/90 backdrop-blur-sm rounded-2xl shadow-xl p-5 flex items-center space-x-4 transition-all duration-300 hover:shadow-lg ${darkColor}`}>
    <div className={`p-3 rounded-lg bg-gradient-to-tr ${color}`}>
      <Icon className="h-6 w-6 text-white" />
    </div>
    <div>
      <h3 className="text-gray-600 dark:text-gray-300 font-medium">{title}</h3>
      <p className="text-xl font-semibold text-gray-800 dark:text-gray-100">{value}</p>
    </div>
  </div>
);

export default StatCard;
